import { render, staticRenderFns } from "./StepperRider.vue?vue&type=template&id=4b7476df&scoped=true"
import script from "./StepperRider.vue?vue&type=script&lang=js"
export * from "./StepperRider.vue?vue&type=script&lang=js"
import style0 from "./StepperRider.vue?vue&type=style&index=0&id=4b7476df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7476df",
  null
  
)

export default component.exports